import { api } from '@cloudsuite/theme_library/scripts/helper';

// RECOMMENDATION PRODUCTS BLOOMREACH
const recommedationContainer =  document.querySelectorAll('[data-js-recommedations]');

if (recommedationContainer.length) {
    recommedationContainer.forEach(recommendationElement => {
        const {
            productListUrl,
            recommendationId,
            tokenUrl,
            viewFunc,
            basketUrl,
            recommendedProducts,
            recommendationLocation,
            trigger,
        } = recommendationElement.dataset;
   
        const toggleElements = recommendationElement.querySelectorAll('[data-js-recommedations-toggle]')
        const recommendation_id = recommendationId;

        const basketItem = JSON.parse(recommendedProducts);

        let RCM_STATUS = 0;
        // render items when loaded

        const onRecommendationsLoaded = function (data) {
            // render items ...
            if (data && data.length > 0) {
                    api.tokenUrl = tokenUrl;
                    const sliderContainer = recommendationElement.querySelector('[data-js-recom-swiper]');
                    let prodIds = [];
                    let observer = null;
                    let str = "";    

                    data.forEach(item => {
                        const url = item.url;
                        const newUrl = new URL(url);
                        const product_id =  newUrl.pathname.split('/').filter(x=>x).pop();
                        prodIds.push(product_id);
                    });

                    
                    if (prodIds.length) {
                        const paramName = 'id=';
                        const arrayAsString = '&' + paramName + prodIds.join('&' + paramName);
                        const urlWithParams = productListUrl + arrayAsString;

                        api.get(urlWithParams)
                            .then(async (response) => {
                                let data = await response;
                                return data;
                            }).then((data) => buildProductTile(data));

                        const buildProductTile = (data) => {
                            recommendationElement.classList.remove('init');

                            toggleElements.forEach(element => {
                                element.classList.remove('hidden');
                            });

                            data.map(item => { 
                                const tags = item.tags[0].description,
                                    price = parseFloat(item.prices.sale),
                                    priceConsumer = parseFloat(item.prices.consumer),
                                    salePrice = price !== priceConsumer,
                                    discountCalculation = (price - priceConsumer) / priceConsumer * 100,
                                    discount = Math.round(discountCalculation),
                                    discountLabelBgcolor = js_translations['discountLabelBgColor'],
                                    discountLabelTextColor = js_translations['discountLabelTextColor'],
                                    discountLabelFontWeight = js_translations['discountLabelFontWeight'];
                                
                                const ega = {
                                    "name": item.name,
                                    "id": item.code,
                                    'price': price,
                                    'brand': item.brand.name ? item.brand.name : 'No brand',
                                    'category': item.trees.map(tree => tree.name).join('/'),
                                    'variant': item.variant && item.variant.name ? item.variant.name : null,
                                }
                                
                                str +=`
                                <div class="swiper-slide">
                                    <div class="product _promo recom-product" data-ega='${JSON.stringify(ega)}' data-id="${item.code}">
                                        <div class="inner">
                                            <div class="inner__top">
                                                ${(salePrice ? `<div class="discount-label" style="background-color: ${discountLabelBgcolor}; font-weight: ${discountLabelFontWeight}; color: ${discountLabelTextColor};">${discount}%</div>` : ``)}
                                                <div class="image">
                                                    <a href="${item.page_link}">
                                                        <img src="${item.picture.normal}" class="img-responsive lazyload" alt="${item.name}"/>
                                                    </a>
                                                </div>
                                                ${(tags ?
                                                `<div class="tag-container tag-and-form-wrapper hidden">
                                                    <div class="product-sale-icon">${tags}</div>
                                                </div>` : `` )} 
                                            </div>
                                            <div class="description">
                                                <h2 class="h4 article-title">
                                                    <a href="${item.page_link}">${item.name}</a>
                                                </h2>
                                                <div class="price">
                                                    ${(salePrice ? `<span class="price-standard">${priceConsumer},-</span> <span class="price-sales">${price},-</span>` : `<span class="price-sales">${price},-</span>` )}
                                                </div>
                                            </div>
                                            </div>
                                            <form action="${basketUrl}" method="POST" class="order-form" data-view-func="${viewFunc}" data-js-ga-trigger="${trigger}">
                                                <input type="hidden" value="${item.id}" name="product">
                                                <input type="hidden" value="1" name="quantity">
                                                
                                                <button class="btn btn-green" type="submit">
                                                    <i class="fal fa-plus"></i>
                                                    <i class="gorb gorb-winkelwagen-up2"></i>
                                                </button>
                                            </form>
                                    </div>
                                </div>`

                                sliderContainer.innerHTML = str;  
                                                    
                                // add click listeners ...
                                // track event recommendation action=click when item is clicked
                                document.querySelectorAll(".recom-product").forEach(function(card){
                                    card.addEventListener("click",function(e){
                                    exponea.track("recommendation", {
                                        action: "click",
                                        item_id: e.currentTarget.dataset.id,
                                        recommendation_id: recommendation_id,
                                        recommendation_name: recommendationLocation
                                        // other properties: placement, ...
                                    });
                                    });
                                });
                            });
                        }
                    }
            
                    const CALLBACK = entries => {
                        entries.forEach(entry => {

                            if (entry.isIntersecting) {

                                // track event recommendation action=show
                                // often, the recommended items are placed below the fold, for proper evalution track "show" event after customer scrolls and see recommended items
                                exponea.track("recommendation", {
                                    action: "show",
                                    item_ids: data
                                    .filter((item) => item.item_id).reduce((acc, item, index) => {
                                        acc[index] = item.item_id;
                                        return acc;
                                    }, {}),
                                    recommendation_id: recommendation_id,
                                    recommendation_name: recommendationLocation,
                                    // other properties: placement, ...
                                });
                                observer.unobserve(entry.target)
                            }
                        });
                    }
            
                    observer = new IntersectionObserver(CALLBACK);
                    observer.observe(recommendationElement);

                    exponea.track("recommendation", {
                        action: "serve",
                        item_ids: data
                        .filter((item) => item.item_id).reduce((acc, item, index) => {
                            acc[index] = item.item_id;
                            return acc;
                        }, {}),
                        recommendation_id: recommendation_id,
                        recommendation_name: recommendationLocation
                        // other properties: placement, ...
                    });

            }
        };

        // recommendations configuration
        const options = {
            recommendationId: recommendation_id,
            size: 10, // Specifies upper limit of the recommendations to return. Defaults to 10.
            callback: onRecommendationsLoaded,
            fillWithRandom: true, // If true, fills the recommendations with random items until size is reached. This is utilized when models cannot recommend enough items.
            // Optional parameters:
            catalogFilter: [], // Adds additional constrains to catalog when retrieving recommended items. Example: [{'property': 'gender', 'constraint': { 'type': 'string', 'operator': 'equals', 'operands': [{'type': 'constant', 'value': 'male'}]}}]
            catalogAttributesWhitelist: [], // Returns only specified attributes from catalog items. If empty or not set, returns everything.
            items: basketItem.products
            .filter((item) => item.id).reduce((acc, item, index) => {
                acc[item.id] = index;
                return acc;
            }, {}),

        };

          // call recommedations
          if (exponea) {
              exponea.getRecommendation(options);
          }
    });
}